import { render, staticRenderFns } from "./v1_mobile.vue?vue&type=template&id=0d12707a&scoped=true&"
import script from "./v1_mobile.vue?vue&type=script&lang=js&"
export * from "./v1_mobile.vue?vue&type=script&lang=js&"
import style0 from "./v1_mobile.vue?vue&type=style&index=0&id=0d12707a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12707a",
  null
  
)

export default component.exports